import React from 'react';
import PropTypes from 'prop-types';

import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField
} from '@mui/material';

import {
  Check,
  Close,
  EditOutlined,
  DeleteOutlined
} from '@mui/icons-material';

import {
  headCellSx,
  bodyCellSx,
  inputSx,
  actionIconSx,
  checkIconSx,
  closeIconSx,
  tableBodyRowSx
} from '../components/Medical_HX_Update/styles';

const EditableTable = ({
  columns,
  rows,
  showAddRow,
  onCancelAdd
}) => {
  return (
    <Table
      stickyHeader
      size="small"
      sx={{
        tableLayout: 'fixed',
        minWidth: 600
      }}>
      <TableHead>
        <TableRow>
          {columns.map(column => (
            <TableCell
              key={column.field}
              sx={{
                ...headCellSx,
                width: column.width,
                position: 'sticky',
                top: 0,
                zIndex: 3,
                bgcolor: '#FAFAFA'
              }}>
              {column.label}
            </TableCell>
          ))}

          <TableCell
            align="center"
            sx={{
              ...headCellSx,
              width: 120,
              position: 'sticky',
              top: 0,
              zIndex: 3,
              bgcolor: '#FAFAFA'
            }}>
            Actions
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {showAddRow && (
          <TableRow sx={tableBodyRowSx}>
            {columns.map(column => (
              <TableCell
                key={column.field}
                sx={{
                  ...bodyCellSx,
                  height: 52
                }}>
                <TextField
                  fullWidth
                  placeholder={column.placeholder}
                  sx={inputSx}
                />
              </TableCell>
            ))}

            <TableCell
              align="center"
              sx={{
                ...bodyCellSx,
                height: 52
              }}>
              <IconButton
                size="small"
                sx={checkIconSx}>
                <Check />
              </IconButton>

              <IconButton
                size="small"
                sx={closeIconSx}
                onClick={onCancelAdd}>
                <Close />
              </IconButton>
            </TableCell>
          </TableRow>
        )}

        {rows.map(row => (
          <TableRow
            key={row.id}
            sx={{
              ...tableBodyRowSx,
              height: 38
            }}>
            {columns.map(column => (
              <TableCell
                key={column.field}
                sx={{
                  ...bodyCellSx,
                  height: 38,
                  py: 0
                }}>
                {row[column.field] || '---'}
              </TableCell>
            ))}

            <TableCell
              align="center"
              sx={{
                ...bodyCellSx,
                height: 38,
                py: 0
              }}>
              <IconButton
                size="small"
                sx={actionIconSx}>
                <EditOutlined />
              </IconButton>

              <IconButton
                size="small"
                sx={actionIconSx}>
                <DeleteOutlined />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

EditableTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  showAddRow: PropTypes.bool,
  onCancelAdd: PropTypes.func
};

export default EditableTable;